module.exports = __webpack_public_path__ + "static/media/Formular-Medium.886ca31b.otf";